import { render, staticRenderFns } from "./login-banner.vue?vue&type=template&id=ec49e9dc&scoped=true"
import script from "./login-banner.vue?vue&type=script&lang=js"
export * from "./login-banner.vue?vue&type=script&lang=js"
import style0 from "./login-banner.vue?vue&type=style&index=0&id=ec49e9dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec49e9dc",
  null
  
)

export default component.exports